<template>
  <div class="header__dropdown-container-inner NavbarMobileTextBrandsComponent">
    <div class="header__dropdown-container-inner-featured-menu-links-container">
      <div class="header-dropdown-list-links-container">
        <ul
          class="header__dropdown-list header__dropdown-list-menu-links-container"
          v-for="(link, index) in block.link_list"
        >
          <li class="header__dropdown-list-item">
            <a class="header__dropdown-link" :href="link.url">{{ link.title }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="header__dropdown-lists-images-container">
      <div class="header__dropdown-lists-images-inner-container">
        <a
          class="header__dropdown-image-link-container"
          v-if="block.brand_image_1_url"
          :href="block.brand_image_1_url"
        >
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.brand_image_1" :alt="block.brand_image_1_alt" />
            </div>
            <div class="header-menu-image-title">
              <div class="header-menu-image-text">{{ block.brand_image_1_text }}</div>
              <div class="header-menu-image-cta">
                <v-link secondary :href="block.brand_image_1_url">
                  {{ block.brand_image_1_cta_text }}
                </v-link>
              </div>
            </div>
          </div>
        </a>
        <a
          class="header__dropdown-image-link-container"
          v-if="block.brand_image_2_url"
          :href="block.brand_image_2_url"
        >
          <div class="header__dropdown-image-link-inner-container">
            <div class="header__dropdown-image-container">
              <img class="header__dropdown-image" :src="block.brand_image_2" :alt="block.brand_image_2_alt" />
            </div>
            <div class="header-menu-image-title">
              <div class="header-menu-image-text">{{ block.brand_image_2_text }}</div>
              <div class="header-menu-image-cta">
                <v-link secondary :href="block.brand_image_2_url">
                  {{ block.brand_image_2_cta_text }}
                </v-link>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';
import VLink from '../buttons/VLink.vue';
import ArrowButton from '../buttons/ArrowButton.vue';

export default {
  name: 'NavbarMobileTextBrands',
  components: { Icon, VLink, ArrowButton },
  props: {
    block: Object,
    // onClose: Function,
  },
};
</script>

<style scoped lang="scss">
.header__dropdown-container-inner {
  display: flex;
  flex-direction: column;
  padding: 35px 38px 52px;
}

.header__dropdown-side-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 32px;
}

.header__dropdown-list {
  margin-top: 0;
  margin-bottom: 0;
  padding: 5px 0;

  &:first-child {
    padding-top: 0;
  }

  @include desktop-up {
    margin-right: 78px;
  }
}

.header__close-button {
  position: absolute;
  top: 23px;
}

// .header__dropdown-featured-link {
//   font-size: 20px;
//   display: flex;
//   align-items: center;
//   margin-bottom: 24px;
//   color: $color-brand-primary;
// }

.mobile-header-menu-image-link-arrow {
  margin-left: 4px;
  color: $color-white;
}

.header__dropdown-list,
.header__dropdown-list ul {
  padding-left: 0;
  list-style: none;
}

.header__dropdown-list-title {
  display: block;
  text-decoration: none;
  margin-bottom: 24px;
  /* color: $color-text-black;
  text-decoration: none;
  font-weight: 500;
  @include body-lg; */
}

.header__dropdown-link {
  display: block;
  margin-bottom: 16px;
  color: $color-text-black;
  /* @include body-sm; */
  text-decoration: none;
  font-size: rem(28);
  line-height: rem(34);
  font-family: $font-family-primary;

    .link {
      font-family: $font-family-secondary;
    }
}

.header__dropdown-container-inner-featured-menu-links-container {
  @include desktop-up {
    width: 50%;
    display: flex;
  }
}

.mobile-header-dropdown-list-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 32px;
}

.header__dropdown-list-links-image-container {
  display: flex;
  flex-direction: row;
}

.header-dropdown-list-links-container {
  ul:last-child {
    .header__dropdown-link {
      margin-bottom: 0;
    }
  }
}

.header__dropdown-image {
  width: 100%;
  display: block;
}

.mobile-header-dropdown-list-image-container {
  display: block;

  @include desktop-up {
    display: none;
  }
}

.header__dropdown-lists-images-inner-container {
  margin-bottom: 33px;
  /* overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden; */
  padding-top: 20px;
  position: relative;
  /* display: flex;
  justify-content: center; */
  margin: 30px 0 0;
  padding-left: 0;
}

.header__dropdown-image-link-container {
  display: block;
  list-style: none;
  width: 224px;
  vertical-align: top;
  margin: 0 auto;
  text-decoration: none;
  text-align: center;
  position: relative;
}

.header__dropdown-image-link-inner-container {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
}

.header__dropdown-image-container {
  margin-top: 20px;
}

.header-menu-image-title {
  display: flex;
  align-items: center;
  color: $color-text-black;
  font-family: $font-family-primary;
  font-size: rem(22);
  line-height: rem(24);
  letter-spacing: rem(-0.1);
  margin-top: 10px;
  width: 100%;
  justify-content: center;
  transform: translateY(.5em);
  flex-direction: column;
}

.header-menu-image-text {
  display: flex;
  align-items: center;
  font-size: rem(18);
  letter-spacing: rem(-0.1);
  justify-content: center;
}

.header-menu-image-cta {
  display: flex;
  align-items: center;
  font-size: rem(14);
  letter-spacing: rem(-0.1);
  margin-top: 5px;
  margin-bottom: 10px;
  justify-content: center;
}

.menu-image-link-arrow {
  margin-left: 4px;
  fill: $color-white;
  display: none;
}

.header__menu-main-inner-link {
  margin-top: 32px;
  color: $color-white;
}
</style>
